import axios from "axios"
import { API_BASE_URL } from "configs/AppConfig"
import { AUTH_TOKEN } from "constants/AuthConstant"

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
})

// Add response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    // A successful response proves we're online — restore online mode if we had flipped offline.
    if (localStorage.getItem("isOffline") === "true") {
      localStorage.setItem("isOffline", "false")
      window.dispatchEvent(new Event("app:online"))
    }
    return response
  },
  (error) => {
    // Ignore request cancellations (e.g. React Query aborting an in-flight query).
    const isCanceled =
      error.code === "ERR_CANCELED" || error.name === "CanceledError"

    if (!error.response && !isCanceled) {
      // True network failure (no internet, DNS, timeout) — auto-switch to offline mode
      localStorage.setItem("isOffline", "true")
      window.dispatchEvent(new Event("app:offline"))
    }

    if (error.response?.status === 401) {
      localStorage.removeItem(AUTH_TOKEN)
      window.location = "/auth/login"
    }

    return Promise.reject(error)
  }
)

export default axiosInstance